import React from 'react'
import './Copyrfooter.css'

export const Copyrfooter = () => {
  return (
    <div className="cfooter text-dark text-center py-3">
    <div className="container d-flex flex-column flex-md-row justify-content-between align-items-center">
      <p className="mb-0">&copy; {new Date().getFullYear()}. All rights reserved.</p>
      <p className="mb-0">
        Design & Developed by <a href="https://shreeshyam.com" target="_blank" rel="noopener noreferrer" className="text-primary text-decoration-none">Shree Shyam Enterprises</a>
      </p>
    </div>
  </div>
  )
}
